module.exports = __webpack_public_path__ + "img/zambia.458cbfed.svg";